(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Arc-carousel-productcard"] && !Shopify.designMode) return;
  try {
    
/* Arc Product Carousel
   Tiny custom element. No dependencies, no Dawn globals.
   Handles arrow buttons, arrow disabled states, and arrow vertical alignment.
   Safe to re-init: the theme editor re-renders the section, which creates a fresh element. */

(() => {
  if (customElements.get('arc-product-carousel')) return;

  class ArcProductCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-arc-pc-track]');
      if (!this.track) return;

      this.prev = this.querySelector('[data-arc-pc-prev]');
      this.next = this.querySelector('[data-arc-pc-next]');
      this.frame = null;

      this.onPrev = () => {
        if (this.prev.getAttribute('aria-disabled') !== 'true') this.step(-1);
      };
      this.onNext = () => {
        if (this.next.getAttribute('aria-disabled') !== 'true') this.step(1);
      };
      this.onScroll = () => this.schedule();

      if (this.prev) this.prev.addEventListener('click', this.onPrev);
      if (this.next) this.next.addEventListener('click', this.onNext);
      this.track.addEventListener('scroll', this.onScroll, { passive: true });

      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(() => this.schedule());
        this.resizeObserver.observe(this.track);
      } else {
        window.addEventListener('resize', this.onScroll, { passive: true });
      }

      this.schedule();
    }

    disconnectedCallback() {
      if (this.prev) this.prev.removeEventListener('click', this.onPrev);
      if (this.next) this.next.removeEventListener('click', this.onNext);
      if (this.track) this.track.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
      if (this.resizeObserver) this.resizeObserver.disconnect();
      if (this.frame) cancelAnimationFrame(this.frame);
    }

    schedule() {
      if (this.frame) return;
      this.frame = requestAnimationFrame(() => {
        this.frame = null;
        this.update();
      });
    }

    isRtl() {
      return getComputedStyle(this.track).direction === 'rtl';
    }

    step(direction) {
      const first = this.track.querySelector('[data-arc-pc-item]');
      if (!first) return;

      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      const distance = first.getBoundingClientRect().width + gap;
      const sign = this.isRtl() ? -1 : 1;
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.track.scrollBy({
        left: direction * sign * distance,
        behavior: reduceMotion ? 'auto' : 'smooth',
      });
    }

    update() {
      const track = this.track;
      const maxScroll = track.scrollWidth - track.clientWidth;
      const position = Math.abs(track.scrollLeft);
      const tolerance = 3;

      // Nothing to scroll: hide arrows entirely
      this.dataset.static = maxScroll <= tolerance ? 'true' : 'false';

      this.setDisabled(this.prev, position <= tolerance);
      this.setDisabled(this.next, position >= maxScroll - tolerance);

      // Keep arrows vertically centered on the product image, whatever the image ratio
      const media = track.querySelector('[data-arc-pc-media]');
      if (media) {
        const hostRect = this.getBoundingClientRect();
        const mediaRect = media.getBoundingClientRect();
        const y = mediaRect.top - hostRect.top + mediaRect.height / 2;
        this.style.setProperty('--arc-pc-arrow-y', `${Math.round(y)}px`);
      }
    }

    setDisabled(button, disabled) {
      if (!button) return;
      button.setAttribute('aria-disabled', disabled ? 'true' : 'false');
      button.tabIndex = disabled ? -1 : 0;
    }
  }

  customElements.define('arc-product-carousel', ArcProductCarousel);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["arc-booking"] && !Shopify.designMode) return;
  try {
    
(function () {
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function init(r) {
    if (r.dataset.bkInit) return;
    r.dataset.bkInit = '1';
    var f = r.querySelector('form'), a = r.querySelector('.arc-bk__btn'), pv = r.querySelector('.arc-bk__pv'), er = r.querySelector('.arc-bk__err');
    if (!f || !a) return;
    var el = f.elements, n = new Date();
    var today = n.getFullYear() + '-' + pad(n.getMonth() + 1) + '-' + pad(n.getDate());
    el.from.min = today; el.until.min = today;
    function digits() { return (r.dataset.wa || '').replace(/\D/g, '').replace(/^0+/, ''); }
    var lang = (r.dataset.lang && r.dataset.lang !== 'en') ? r.dataset.lang : 'en-GB', o = { day: 'numeric', month: 'short' };
    function fmt(v) {
      if (!v) return '';
      var p = v.split('-'), d = new Date(+p[0], +p[1] - 1, +p[2]);
      try { return d.toLocaleDateString(lang + '-u-nu-latn', o); } catch (e) {
        try { return d.toLocaleDateString('en-GB', o); } catch (e2) { return v; }
      }
    }
    function build() {
      var t = f.querySelector('input[name=time]:checked');
      var map = { name: (el.first.value.trim() + ' ' + el.last.value.trim()).trim(), service: el.service.value, from: fmt(el.from.value), until: fmt(el.until.value), time: t ? t.getAttribute('data-msg') : '', notes: el.notes.value.trim() };
      var out = [];
      (r.dataset.tpl || '').split(/\r?\n/).forEach(function (l) {
        var skip = false;
        var s = l.replace(/\{(\w+)\}/g, function (m, k) { if (!(k in map)) return m; if (!map[k]) skip = true; return map[k]; });
        if (!skip && s.trim()) out.push(s);
      });
      return out.join('\n');
    }
    function dates() {
      el.until.min = el.from.value || today;
      el.until.setCustomValidity(el.from.value && el.until.value && el.until.value < el.from.value ? (r.dataset.derr || 'Please choose an end date after your start date.') : '');
    }
    function update() {
      dates();
      var m = build();
      pv.textContent = m;
      a.href = 'https://wa.me/' + digits() + '?text=' + encodeURIComponent(m);
    }
    f.addEventListener('input', update);
    f.addEventListener('change', update);
    f.addEventListener('submit', function (e) { e.preventDefault(); a.click(); });
    a.addEventListener('click', function (e) {
      if (digits().length < 8) { e.preventDefault(); if (er) er.hidden = false; return; }
      if (er) er.hidden = true;
      update();
      if (!f.reportValidity()) e.preventDefault();
    });
    update();
  }
  function all(root) { (root || document).querySelectorAll('.arc-bk').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { all(); }); else all();
  document.addEventListener('shopify:section:load', function (e) { all(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["arc-concern-picker"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function sync(root, id, holdCard) {
      var heldCard = holdCard ? cardFor(root, id) : null;
      var keepTop = heldCard ? heldCard.getBoundingClientRect().top : undefined;
      var results = root.querySelectorAll('.arc-cp__result');
      var panel = root.querySelector('.arc-cp__panel');
      var found = false;
      for (var i = 0; i < results.length; i++) {
        var on = id !== null && results[i].getAttribute('data-block-id') === id;
        results[i].classList.toggle('is-active', on);
        if (on) found = true;
      }
      placePanel(root, id, keepTop);
      if (panel) {
        if (found) panel.removeAttribute('data-arc-cp-empty');
        else panel.setAttribute('data-arc-cp-empty', '');
      }
    }

    // Mobile only: the product opens directly under the tapped concern.
    // Desktop keeps the panel in its own column on the right.
    var ARC_CP_MOBILE = '(max-width: 749px)';

    function cardFor(root, id) {
      if (id === null) return null;
      var radio = root.querySelector('.arc-cp__radio[value="' + id + '"]');
      return radio ? radio.nextElementSibling : null;
    }

    function placePanel(root, id, keepTop) {
      var panel = root.querySelector('.arc-cp__panel');
      var layout = root.querySelector('.arc-cp__layout');
      if (!panel) return;
      if (!layout) return;
      var card = cardFor(root, id);
      var target = layout;
      if (card && window.matchMedia(ARC_CP_MOBILE).matches) target = card.parentNode;
      if (panel.parentNode !== target) target.appendChild(panel);
      // Closing a panel above the tapped card would make the card jump: hold it still
      if (card && typeof keepTop === 'number') {
        var shift = card.getBoundingClientRect().top - keepTop;
        if (shift) window.scrollBy({ top: shift, left: 0, behavior: 'instant' });
      }
    }

    function initRoot(root) {
      if (root.getAttribute('data-arc-cp-ready') === 'true') return;
      root.setAttribute('data-arc-cp-ready', 'true');
      root.classList.add('arc-cp--js');

      var radios = root.querySelectorAll('.arc-cp__radio');
      // 0 or 1 concern: no cards, the server-rendered result is already visible
      if (!radios.length) return;

      var checked = root.querySelector('.arc-cp__radio:checked');
      sync(root, checked ? checked.value : null);

      var closedByTap = false;
      var mobileQuery = window.matchMedia(ARC_CP_MOBILE);
      var onViewportChange = function () {
        var current = root.querySelector('.arc-cp__radio:checked');
        // Back on desktop with everything closed: reopen the first concern so the right column is not empty
        if (!current && closedByTap && !mobileQuery.matches) {
          closedByTap = false;
          radios[0].checked = true;
          sync(root, radios[0].value);
          return;
        }
        placePanel(root, current ? current.value : null);
      };
      if (mobileQuery.addEventListener) mobileQuery.addEventListener('change', onViewportChange);

      // Mobile only: tapping the concern that is already open closes it
      root.addEventListener('click', function (event) {
        var card = event.target.closest ? event.target.closest('.arc-cp__card') : null;
        if (!card) return;
        var radio = card.previousElementSibling;
        if (!radio) return;
        if (!radio.checked) return;
        if (!window.matchMedia(ARC_CP_MOBILE).matches) return;
        event.preventDefault();
        radio.checked = false;
        closedByTap = true;
        sync(root, null);
      });

      root.addEventListener('change', function (event) {
        var target = event.target;
        if (target && target.classList && target.classList.contains('arc-cp__radio')) {
          root.classList.add('arc-cp--animate');
          sync(root, target.value, true);
        }
      });

      root.addEventListener('shopify:block:select', function (event) {
        var blockId = event.detail && event.detail.blockId;
        if (!blockId) return;
        var list = root.querySelectorAll('.arc-cp__radio');
        for (var i = 0; i < list.length; i++) {
          if (list[i].value === blockId) {
            list[i].checked = true;
            root.classList.add('arc-cp--animate');
            sync(root, blockId, true);
            break;
          }
        }
      });
    }

    function init(scope) {
      var roots = (scope || document).querySelectorAll('.arc-cp');
      for (var i = 0; i < roots.length; i++) initRoot(roots[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(document); });
    } else {
      init(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["arc-sticky-atc"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var cleanups = [];

    function mainButton() {
      return document.querySelector('product-form button[type="submit"][name="add"]');
    }

    function init(root) {
      if (!root || root.getAttribute('data-arc-sa-ready') === 'true') return;
      root.setAttribute('data-arc-sa-ready', 'true');

      var btn = root.querySelector('[data-arc-sa-btn]');
      var when = root.getAttribute('data-when') || 'past';
      var multi = root.getAttribute('data-multi') === 'true';
      var canBuy = root.getAttribute('data-can-buy') === 'true';
      var target = mainButton();
      var visible = false;
      var idleLabel = btn ? btn.textContent : '';
      var hideAfterAdd = root.getAttribute('data-hide-after-add') === 'true';
      var productId = Number(root.getAttribute('data-product-id'));
      var cartJson = root.getAttribute('data-cart-json');
      var inCart = false;

      function show(on) {
        // once the product is in the cart the bar never comes back
        if (on && hideAfterAdd && inCart) on = false;
        if (on === visible) return;
        visible = on;
        root.classList.toggle('is-visible', on);
        root.setAttribute('aria-hidden', on ? 'false' : 'true');
        // keep the bottom of the page reachable while the bar is showing
        document.body.style.paddingBottom = on && root.offsetHeight ? root.offsetHeight + 'px' : '';
      }

      function checkCart() {
        if (!hideAfterAdd || !cartJson || !window.fetch) return;
        fetch(cartJson, { headers: { 'Accept': 'application/json' }, cache: 'no-store' })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var found = false;
            (cart.items || []).forEach(function (it) { if (it.product_id === productId) found = true; });
            inCart = found;
            if (inCart) show(false);
          })
          .catch(function () {});
      }

      var observer = null;
      if (target && 'IntersectionObserver' in window) {
        observer = new IntersectionObserver(function (entries) {
          var e = entries[entries.length - 1];
          if (e.isIntersecting) { show(false); return; }
          var passed = e.boundingClientRect.top < 0;
          show(when === 'offscreen' ? true : passed);
        }, { threshold: 0 });
        observer.observe(target);
      } else {
        // no real button found (or very old browser): show after a little scrolling
        var onScroll = function () { show(window.scrollY > 500); };
        window.addEventListener('scroll', onScroll, { passive: true });
        cleanups.push(function () { window.removeEventListener('scroll', onScroll); });
        onScroll();
      }

      function scrollToOptions() {
        var form = document.querySelector('product-form') || target;
        if (!form) return;
        var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        form.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
      }

      function fallbackAdd() {
        var id = root.getAttribute('data-variant-id');
        btn.disabled = true;
        btn.textContent = root.getAttribute('data-adding') || '...';
        fetch(root.getAttribute('data-add-url'), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: Number(id), quantity: 1 })
        }).then(function (r) {
          if (!r.ok) throw new Error('add failed');
          window.location.href = root.getAttribute('data-cart-url');
        }).catch(function () {
          btn.disabled = false;
          btn.textContent = idleLabel;
        });
      }

      function onClick() {
        if (!canBuy || btn.disabled) return;
        if (multi) { scrollToOptions(); return; }
        var real = mainButton();
        if (real && !real.disabled && real.getAttribute('aria-disabled') !== 'true') {
          // press the theme's own button: same cart behaviour, same errors, same rules
          real.click();
          btn.setAttribute('aria-busy', 'true');
          btn.textContent = root.getAttribute('data-adding') || '...';
          setTimeout(function () {
            btn.textContent = idleLabel;
            btn.removeAttribute('aria-busy');
          }, 1400);
        } else if (!real) {
          fallbackAdd();
        }
      }

      if (btn) btn.addEventListener('click', onClick);

      if (hideAfterAdd) {
        // any add from the product form (main button or this bar) -> re-check the cart a moment later
        var onSubmit = function (e) {
          var f = e.target;
          if (f && f.closest && f.closest('product-form')) setTimeout(checkCart, 1200);
        };
        document.addEventListener('submit', onSubmit, true);
        cleanups.push(function () { document.removeEventListener('submit', onSubmit, true); });

        // the theme announces cart changes: react instantly when that is available
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
          var unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, checkCart);
          cleanups.push(function () { if (typeof unsubscribe === 'function') unsubscribe(); });
        }

        // already in the cart when the page loads (came back to the product): stay hidden
        checkCart();
      }

      cleanups.push(function () {
        if (observer) observer.disconnect();
        if (btn) btn.removeEventListener('click', onClick);
        document.body.style.paddingBottom = '';
      });
    }

    function boot() { init(document.querySelector('[data-arc-sa]')); }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', boot);
    document.addEventListener('shopify:section:unload', function () {
      while (cleanups.length) cleanups.pop()();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
